import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Floating CTA for the home page. It mirrors the hero "CONTACT US" button and
// pins to the top-centre of the screen once the hero button has scrolled up out
// of view — so it feels like the hero button "detaches" and follows the scroll.
export const FloatingContact = () => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const heroBtn = document.querySelector(
                '[data-testid="hero-get-started"]',
            );
            if (heroBtn) {
                // Show once the hero button passes above the navbar area (~72px).
                setVisible(heroBtn.getBoundingClientRect().bottom < 72);
            } else {
                setVisible(window.scrollY > window.innerHeight * 0.6);
            }
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
    }, []);

    return (
        <button
            data-testid="floating-contact"
            aria-label="Contact us"
            onClick={() => navigate("/contact")}
            className={`fixed top-[84px] left-1/2 -translate-x-1/2 z-40 group font-mono text-sm tracking-[-0.01em] bg-black text-white pl-6 pr-5 py-3 rounded-full inline-flex items-center gap-2.5 shadow-[0_12px_36px_-10px_rgba(0,0,0,0.55)] transition-all duration-500 hover:bg-neon hover:text-black hover:shadow-[0_0_28px_rgba(20,184,166,0.55)] ${
                visible
                    ? "opacity-100 translate-y-0 pointer-events-auto"
                    : "opacity-0 -translate-y-3 pointer-events-none"
            }`}
        >
            CONTACT US
            <ArrowRight
                size={16}
                className="group-hover:translate-x-1 transition-transform"
            />
        </button>
    );
};
